//@flow
import _ from 'lodash';

class Enum {
    keyToValueMap: { [key: string]: string };
    valueToKeyMap: { [key: string]: string };
    constructor(args: { [key: string]: string }) {
        this.keyToValueMap = {};
        this.valueToKeyMap = {};
        let value: string;
        _.keys(args).forEach((key: string): void => {
            value = args[key];
            this[key] = value;
            this.keyToValueMap[key] = value;
            this.valueToKeyMap[value] = key;
        });
    }

    createNew(args: { [key: string]: string }) {
        return new Enum(args);
    }

    omit(key: string): this {
        const newKeyToValueMap = _.omit(this.keyToValueMap, key);
        return this.createNew(newKeyToValueMap);
    }

    keys(): Array<string> {
        return _.keys(this.keyToValueMap);
    }

    values(): Array<string> {
        return _.keys(this.valueToKeyMap);
    }

    findByKey(key: string) {
        return this.keyToValueMap[key];
    }

    findByValue(value: string) {
        return this.valueToKeyMap[value];
    }
}

export default Enum;
